import { type ReactNode, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Icon, type IIconsVector } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/styles.module.scss'
import { ProviderPageDoubleOptIn } from 'pages/settings/pages/doubleOptIn/context/doubleOptInContext'
import {
  DoubleOptInPageStore,
  type BooleanSwitchOption,
} from 'pages/settings/pages/doubleOptIn/store/doubleOptInPageStore'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'

interface AircallSettingItemProps {
  icon: IIconsVector
  option: BooleanSwitchOption
  title: ReactNode
  description: string
  onUpdate: (value: boolean) => void
}

export const AircallSettingItem = observer(
  ({ icon, option, title, description, onUpdate }: AircallSettingItemProps) => {
    const entities = useEntitiesContext()
    const store = useMemo(() => new DoubleOptInPageStore(entities), [])

    const checked = Boolean(store[option])

    return (
      <ProviderPageDoubleOptIn value={store}>
        <div className={styles.collapseWithIcon}>
          <div className={styles.iconWrapper}>
            <Icon fontSize={16} icon={icon} color={'var(--content-primary-tertiary)'} />
          </div>
          <DoubleOptInSettingLayout
            title={title}
            description={description}
            checked={checked}
            className={styles.doubleOptInSettingLayout}
            onToggle={(value) => {
              store.handleBooleanSwitcher(option, value)

              if (entities.organizationStore.organization_call && entities.organizationStore.id) {
                onUpdate(value)
              }
            }}
            disabled={store.switchLoadingMap[option]}
          />
        </div>
      </ProviderPageDoubleOptIn>
    )
  }
)
